import React, { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { axios } from '../hooks/useAuth';

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }

    setLoading(true);
    setError('');
    try {
      await axios.post(`/api/auth/reset-password/${token}`, { password });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 64px)', padding: 20 }}>
      <div className="card page-enter" style={{ width: '100%', maxWidth: 400, padding: 40 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 48 }}>🔐</div>
          <h2 style={{ marginTop: 12 }}>Reset Password</h2>
        </div>

        {success ? (
          <div className="alert alert-success" style={{ textAlign: 'center' }}>
            ✅ Password reset! Redirecting to login...
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-error">{error}</div>}
            <div className="form-group">
              <label className="form-label">New Password</label>
              <input type="password" className="form-input" required
                value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Min. 8 characters" minLength={8} />
            </div>
            <div className="form-group">
              <label className="form-label">Confirm Password</label>
              <input type="password" className="form-input" required
                value={confirm} onChange={e => setConfirm(e.target.value)} />
            </div>
            <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
              {loading ? '⏳ Resetting...' : '🔐 Reset Password'}
            </button>
            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <Link to="/login" className="text-secondary text-sm">Back to login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
